var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIcoArrowUpRight = function SvgIcoArrowUpRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 73",
    d: "M0 0h24v24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 10",
    d: "M6.295 17.708a.994.994 0 0 1 0-1.414l8.29-8.293H8a1 1 0 0 1-1-1 1 1 0 0 1 1-1h9a1 1 0 0 1 1 .953v9.047a1 1 0 0 1-1 1 1 1 0 0 1-1-1V9.414l-8.293 8.3a1.009 1.009 0 0 1-.708.291.994.994 0 0 1-.704-.297Z",
    fill: "#35272a"
  })));
};

export default SvgIcoArrowUpRight;